(function () {
    'use strict';

    angular.module('swif.parcauto')
    .config(['$routeProvider', 'swifParcautoConstant', function($routeProvider, constant) {
        $routeProvider.when(constant.configuration.routes.configuration_view, {
            templateUrl: 'partials/parcauto/configuration_view.html',
            controller: 'ParcAutoConfigurationController',
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.configuration.resolveData();
                }]
            }
        });
    }])

    .controller('ParcAutoConfigurationController', ['$scope', 'data', 'swifFrameworkService',
        function ($scope, data, swif) {
            console.log('ParcAutoConfigurationController');
            swif.settings.page.title = 'Parc auto module configuration';
            $scope.data = data;
            $scope.refresh = function () {
                $scope.data.brands.getItems();
                $scope.data.models.getItems();
                $scope.data.types.getItems();
                $scope.data.fuels.getItems();
            };
        }
    ])

    .controller('ParcAutoBrandController', [
        '$scope', '$location', 'swifFrameworkService',
        function ($scope, $location, swif) {
            console.log('init ParcAutoBrandController');
            swif.message.addOnErrorHandler($scope);
            $scope.debug = $location.search().debug;

            $scope.brands = $scope.data.brands;
            $scope.preValidate = function (data) {
                return $scope.brands.preValidate(data);
            };
            $scope.callback = function (error, data) {
                $scope.brands.defaultActionCallback(error, data);
            };
        }
    ])

    .controller('ParcAutoModelController', [
        '$scope', '$location', 'swifFrameworkService',
        function ($scope, $location, swif) {
            console.log('init ParcModeFuelController');
            swif.message.addOnErrorHandler($scope);
            $scope.debug = $location.search().debug;

            $scope.models = $scope.data.models;
            $scope.preValidate = function (data) {
                return $scope.models.preValidate(data);
            };
            $scope.callback = function (error, data) {
                $scope.models.defaultActionCallback(error, data);
            };
            $scope.toggleShowPhoto = function (model) {
                model._show_photo = !model._show_photo;
            };
        }
    ])


    .controller('ParcAutoTypeController', [
        '$scope', '$location', 'swifFrameworkService',
        function ($scope, $location, swif) {
            console.log('init ParcAutoTypeController');
            swif.message.addOnErrorHandler($scope);
            $scope.debug = $location.search().debug;

            $scope.types = $scope.data.types;
            $scope.preValidate = function (data) {
                return $scope.types.preValidate(data);
            };
            $scope.callback = function (error, data) {
                $scope.types.defaultActionCallback(error, data);
            };
        }
    ])


    .controller('ParcAutoFuelController', [
        '$scope', '$location', 'swifFrameworkService',
        function ($scope, $location, swif) {
            console.log('init ParcAutoFuelController');
            swif.message.addOnErrorHandler($scope);
            $scope.debug = $location.search().debug;
            $scope.fuels = $scope.data.fuels;
            $scope.preValidate = function (data) {
                return $scope.fuels.preValidate(data);
            };
            $scope.callback = function (error, data) {
                $scope.fuels.defaultActionCallback(error, data);
            };
        }
    ]);

})();
